/* @flow */
import FreeClassMembershipLimitNoticeContainer from './FreeClassMembershipLimitNoticeContainer';

export default FreeClassMembershipLimitNoticeContainer;
